import React, { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import UIButton from 'Components/UIComponents/UIButton';
import UIModal from 'Components/UIComponents/UIModal';
import useIsMobile from 'Hooks/Common/useIsMobile';
import { AuthorizedRoutePaths } from 'Interfaces/RoutePaths';

import IconDeclined from 'Assets/images/icons/circle-declined.svg';

interface DocumentDeclineModalProps {
  onClose?: () => void;
  onConfirm?: () => void;
}

const DocumentDeclineModal = ({ onClose, onConfirm }: DocumentDeclineModalProps) => {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const navigateToDocuments = useCallback(() => {
    navigate(AuthorizedRoutePaths.DOCUMENTS);
  }, [navigate]);

  return (
    <UIModal
      onClose={onClose || navigateToDocuments}
      className={classNames('successSendModal', {
        mobile: isMobile,
      })}
      hideCloseIcon
      shouldCloseOnOverlayClick={false}
    >
      <div
        className={classNames(
          'successSendModal__main',
          'successSendModal__main--banBorderBottom',
        )}
      >
        <ReactSVG src={IconDeclined} className="successSendModal__main-icon" />
        <div className="successSendModal__text-wrapper">
          <p className="successSendModal__title">Document Declined</p>
          <p className="successSendModal__text">
            Your decision to decline signing this document has been noted.
            <br />
            The sender will receive a notification regarding your decline.
          </p>
        </div>
        <UIButton
          priority="primary"
          className="successSendModal__button"
          handleClick={onConfirm || navigateToDocuments}
          title={`Return to Documents`}
        />
      </div>
    </UIModal>
  );
};

export default DocumentDeclineModal;
